import { MAX_RECENT } from './recentDocumentsStore'

/**
 * Documents the user attached most recently first, then the rest of the library
 * newest-first. Ids come from local history but every rendered row comes from
 * the live library, so a deleted document just drops out of the list.
 *
 * @param {{ id?: string, status?: string, updatedAtMs?: number }[]} items
 * @param {string[]} recentIds
 */
export function rankRecentDocuments(items = [], recentIds = []) {
  // A failed document cannot be answered from — attaching it is a dead end.
  const usable = items.filter((item) => item?.id && item.status !== 'failed')
  const byId = new Map(usable.map((item) => [item.id, item]))

  const touched = []
  for (const id of recentIds) {
    const item = byId.get(id)
    if (!item) continue
    byId.delete(id)
    touched.push(item)
  }

  const rest = [...byId.values()].sort((a, b) => (b.updatedAtMs ?? 0) - (a.updatedAtMs ?? 0))
  return [...touched, ...rest].slice(0, MAX_RECENT)
}
